import React, { useState } from 'react';
import styles from './FirstScreen.module.css';
import Popped from '../components/poppedUpWindow/Popped'; // ודא שהנתיב נכון

const HeroSection = () => {
  const [isPoppedOpen, setIsPoppedOpen] = useState(false);
  
  const scrollToServices = (e) => {
    e.preventDefault();
    const servicesSection = document.getElementById('שירותי המשרד');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    const phoneNumber = "+972508919747";
    const message = "היי המשרד הגעתי מהדף שלכן, אני רוצה לשמוע מכן עוד על..";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  const handleButtonClick = () => {
    setIsPoppedOpen(true);
  };

  return (
    <>
      <header className={styles.container}>
        
        {/* אלמנטים דקורטיביים */}

        
        {/* תוכן */}
        <div className={styles.contentWrapper}>
          
          {/* תת כותרת אינטרו */}
          <div className={styles.introWrapper}>
            <p className={styles.introText}>
              אתם מרוויחים יפה - אבל עובדים בלי סוף. הבית סופג, הלחץ מצטבר,<br />
              ואתם יודעים שמשהו חייב להשתנות!
            </p>
          </div>

          {/* כותרת ראשית */}
          <h1 className={styles.title}>
            מפסיקים לעבוד <span className={styles.strikethrough}>בתוך</span> העסק.<br />
            ומתחילים לעבוד <span className={styles.highlight}>על</span> העסק עם המשרד A.
          </h1>

          <p className={styles.subtitle}>
            אנחנו לא שירותי מזכירות. אנחנו הזרוע הניהולית של העסק שלך - גבייה, לידים, תיאומים, סדר וארגון - הכול מנוהל בשיטה ברורה, כדי שתצליח להתעסק במה שמכניס כסף.
          </p>

          <div className={styles.buttonsContainer}>
            <button 
              onClick={handleButtonClick}
              className={`${styles.btn} ${styles.btnPrimary}`}
            >
              לשיחת היכרות ללא התחייבות
            </button>
          </div>
        </div>
      </header>
      
      {isPoppedOpen && <Popped onClose={() => setIsPoppedOpen(false)} />}
    </>
  );
};

export default HeroSection;